import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaChartBar,
  FaUsers,
  FaExchangeAlt,
  FaHistory,
  FaCog,
  FaGlobe,
  FaShieldAlt,
  FaBell,
  FaFileAlt,
  FaCoins,
  FaGift,
  FaEnvelope
} from "react-icons/fa";
import { useTheme } from "../../contexts/ThemeContext";

const AdminSidebar = ({ isOpen }) => {
  const { darkMode } = useTheme();

  const navItems = [
    { path: "/admin/dashboard", name: "Tableau de bord", icon: <FaChartBar /> },
    { path: "/admin/users", name: "Utilisateurs", icon: <FaUsers /> },
    {
      path: "/admin/transactions",
      name: "Transactions",
      icon: <FaExchangeAlt />,
    },
    { path: "/admin/airdrops", name: "Airdrops", icon: <FaGift /> },
    { path: "/admin/logs", name: "Journaux", icon: <FaHistory /> },
    { path: "/admin/rates", name: "Taux de Change", icon: <FaGlobe /> },
    { path: "/admin/bbt", name: "Gestion BBT", icon: <FaCoins /> },
    { path: "/admin/reports", name: "Rapports", icon: <FaFileAlt /> },
    { path: "/admin/alerts", name: "Alertes", icon: <FaBell /> },
    { path: "/admin/security", name: "Sécurité", icon: <FaShieldAlt /> },
    { path: "/admin/mass-email", name: "Emails en Masse", icon: <FaEnvelope /> },
    { path: "/admin/settings", name: "Paramètres", icon: <FaCog /> },
  ];

  return (
    <div
      className={`${
        isOpen ? "w-64" : "w-20"
      } fixed left-0 top-0 bottom-0 bg-white dark:bg-slate-900 shadow-lg transition-width duration-300 ease-in-out pt-16 z-20 overflow-y-auto overflow-x-hidden border-r border-gray-200 dark:border-slate-700`}
    >
      <div className="flex flex-col h-full">
        <div className="flex-1 p-3">
          <ul className="space-y-1">
            {navItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center p-3 rounded-lg transition-colors ${
                      isActive
                        ? "bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400"
                        : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800"
                    } ${!isOpen && "justify-center"}`
                  }
                >
                  <span className="text-lg">{item.icon}</span>
                  {isOpen && (
                    <span className="ml-3 text-sm font-medium">
                      {item.name}
                    </span>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div className="p-4 border-t border-gray-200 dark:border-slate-700">
          <div
            className={`text-xs text-center text-gray-500 dark:text-gray-400 ${!isOpen && "hidden"}`}
          >
            Baobab Exchange Admin v1.0
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
